const graphScopes = (
  import.meta.env.VITE_GRAPH_SCOPES || "User.Read Calendars.ReadWrite Contacts.Read"
)
  .split(/\s+/)
  .filter(Boolean);

export const authConfig = {
  clientId: import.meta.env.VITE_AAD_CLIENT_ID,
  tenantId: import.meta.env.VITE_AAD_TENANT_ID,
  graphScopes,
  // Empty in dev (Vite proxies /api to the Functions host); Function App URL in prod.
  backendUrl: import.meta.env.VITE_BACKEND_URL || "",
  // "common" supports both work/school and personal Microsoft accounts (the fallback path).
  msalAuthority: "https://login.microsoftonline.com/common",
  get dialogUrl() {
    return `${window.location.origin}/dialog.html`;
  },
};
